import F1Engine from './F1Engine';

export default function RaceSimulation() {
  return <F1Engine />;
}
